<template>
  <v-card class="chat-image elevation-0">
    <v-card-subtitle>
      <v-row no-gutters>
        Image
        <v-spacer />
        <v-icon>image</v-icon>
      </v-row>
    </v-card-subtitle>
    <v-card-actions @click="show = !show">
      <v-btn x-small text>
        {{ show ? 'réduire' : 'afficher' }}
      </v-btn>
      <v-spacer />
      <v-btn icon>
        <v-icon>{{ show ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-expand-transition>
      <v-row v-if="show" no-gutters justify="center">
        <v-divider />
        <v-img
          max-height="150" max-width="250" :src="smallImg" :lazy-src="smallImg"
          contain>
          <template #placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="grey lighten-5" />
            </v-row>
          </template>
          <v-icon small class="expand-icon" @click="dialog = true">
            fullscreen
          </v-icon>
        </v-img>
      </v-row>
    </v-expand-transition>
    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card class="pa-0 overflow-hidden">
        <v-card-text>
          <v-row no-gutters justify="end">
            <v-btn icon @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-row>
          <v-img
            :src="largeImg" :lazy-src="largeImg" max-height="563" max-width="1000"
            contain>
            <template #placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5" />
              </v-row>
            </template>
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import config from '@/utils/apiUtils'
import ChatUtils from '@/utils/chatUtils'
import moment from 'moment'

export default {
  name: 'ChatImageComponent',
  props: ['file', 'date'],
  data() {
    return {
      smallImg: '',
      largeImg: '',
      dialog: false,
      show: false,
    }
  },
  computed: {

  },
  watch: {
    show(selected) {
      if (selected) {
        this.getImage(this.file)
      }
    },
    dialog(selected) {
      if (selected) {
        this.getImage(this.file)
      }
    },
  },
  created() {
    // if photo < 20 days, show : true
    const receivedDate = moment(this.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
    if (!this.isMoreThan20DaysFromNow(receivedDate)) {
      this.show = true
    }
  },
  methods: {
    isMoreThan20DaysFromNow(inputDate) {
      const date = moment(inputDate)
      const now = moment()
      const diff = Math.abs(date.diff(now, 'days'))
      return diff > 20
    },
    buildImageUrl(image, width, height) {
      const base = ChatUtils.isFullUrl(image)
        ? image
        : config().chatImageApi + ChatUtils.ensureJpgExtension(image)

      if (width && height) {
        const separator = base.includes('?') ? '&' : '?'
        return `${base}${separator}h=${height}&w=${width}`
      }

      return base
    },
      getImage(file) {
      if (!file) return

      const smallUrl = this.buildImageUrl(file, 640, 480) // taille réduite
      const largeUrl = this.buildImageUrl(file) // taille complète

      // D'abord charger la petite image
      fetch(smallUrl)
        .then((res) => {
          if (!res.ok) throw new Error('Erreur chargement small image')
          this.smallImg = smallUrl
            return fetch(largeUrl)
        })
        .then((res) => {
          if (!res.ok) throw new Error('Erreur chargement large image')
          this.largeImg = largeUrl
        })
        .catch((err) => {
            console.error('Erreur chargement image', err)
        })
    },

  },
}
</script>
<style lang="scss" scoped>

.chat-image {
  border-radius: 8px;
  min-width: 250px;
}
.expand-icon {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background-color: white;
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
</style>
